module.exports = __webpack_public_path__ + "img/hybrid-cloud.24811015.svg";